<img [ngSrc]="imageSrc" [width]="width" [height]="height" [alt]="alt" (load)="onLoadedImage()" (error)="takeFallbackImage()" />
